import { IChatChannel, IChatUser } from "../models/Chat";

export function initialsFor(user: Pick<IChatUser, "forename" | "surname">): string {
  return `${user.forename?.[0] ?? ""}${user.surname?.[0] ?? ""}`.toUpperCase();
}

export function fullNameFor(user: Pick<IChatUser, "forename" | "surname">): string {
  return `${user.forename ?? ""} ${user.surname ?? ""}`.trim();
}

/** Label for a channel — `#general` for named rooms, the other member's
 * name for DMs. */
export function channelLabel(
  channel: IChatChannel,
  meId: string | null,
  usersById: Map<string, IChatUser>
): string {
  if (channel.kind === "channel") return `#${channel.name}`;
  const otherId = channel.memberIds.find((id) => id !== meId);
  if (!otherId) return "Direct message";
  const other = usersById.get(otherId);
  return other ? fullNameFor(other) : "Direct message";
}

/** Slack-style normalisation of a channel name. Mirrors the server-side
 * `NormaliseChannelName` so optimistic UI matches what the backend stores. */
export function normaliseChannelName(input: string): string {
  return (input || "")
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9-]+/g, "-")
    .replace(/^-+|-+$/g, "")
    .slice(0, 40) || "channel";
}
